export default __webpack_public_path__ + "assets/models/c21c997318e590bd173ebdbe454c7bb2.glb";